<template>
  <div>
    <div v-if="arquivoEstruturado.length"
         class="section my-3">
      <div class="section_header mb-3">
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col">
            <h2 class="section_header_title">
              Genitores
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div v-for="(genitor, index) in arquivoEstruturado"
         :key="index"
         class="boxGenitor mb-4">
      <div class="boxGenitor_header p-2">
        <h3 class="boxGenitor_header_title">
          {{ genitor.nome }}
        </h3>
      </div>

      <div class="boxGenitor_body px-3 py-2">
        <div class="row no-gutters align-items-center">
          <div class="d-inline-flex boxGenitor_body_content">
            <div v-if="tipoRegistro === 'nascimento'" 
                 class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  CPF
                </li>

                <li class="boxGenitor_list_item">
                  <strong>{{ tratarDados('cpf', genitor.cpf) }}</strong>
                </li>
              </ul>
            </div>

            <div class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  Profissão
                </li>

                <li class="boxGenitor_list_item">
                  <strong>{{ genitor.profissao || 'Não cadastrado' }}</strong>
                </li>
              </ul>
            </div>

            <div v-if="genitor.nacionalidade"
                 class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  Nacionalidade
                </li>

                <li class="boxGenitor_list_item">
                  <strong>{{ tratarDados('nacionalidade', genitor.nacionalidade) }}</strong>
                </li>
              </ul>
            </div>

            <div v-if="genitor.naturalidade"
                 class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  Naturalidade
                </li>

                <li class="boxGenitor_list_item">
                  <strong>{{ genitor.naturalidade || 'Não cadastrado' }}</strong>
                </li>
              </ul>
            </div>

            <div v-if="genitor.naturalidade_uf"
                 class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  UF
                </li>

                <li class="boxGenitor_list_item">
                  <strong>{{ genitor.naturalidade_uf || 'Não cadastrado' }}</strong>
                </li>
              </ul>
            </div>

            <div v-if="tipoRegistro === 'obito'" 
                 class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  Sexo
                </li>

                <li class="boxGenitor_list_item">
                  <strong>{{ tratarDados('sexo', genitor.sexo) }}</strong>
                </li>
              </ul>
            </div>

            <div v-if="tipoRegistro === 'obito'" 
                 class="d-inline-block mr-5">
              <ul class="boxGenitor_list">
                <li class="boxGenitor_list_item boxGenitor_list_title">
                  Endereço
                </li>

                <li class="boxGenitor_list_item">
                  <strong>{{ tratarDados('endereco', genitor.endereco_residencia_filiacao) }}</strong>
                </li>
              </ul>
            </div>
          </div>

          <div v-if="tipoRegistro === 'nascimento'"  
               class="ml-auto">
            <b-button class="btn btn-primary"
                      @click="abrirModalGenitor(genitor)">
              Visualizar mais informações
            </b-button>
          </div>
        </div>
      </div>

      <BoxAvos v-if="genitor.ascendentes && genitor.ascendentes.length"
               :prop-genitor="{ filiacao: genitor.ascendentes }" />
    </div>

    <ModalInformacoesGenitor :genitor="genitorSelecionado" />
  </div>
</template>

<script>
  /* components */
  import BoxAvos from '@/components/SofiaRei/Obito/BoxAvos.vue'
  import ModalInformacoesGenitor from '@/components/SofiaRei/EProtocolo/ArquivosEstruturados/ModalInformacoesGenitor.vue'

  export default {
    name: 'Genitores',
    components: {
      BoxAvos,
      ModalInformacoesGenitor
    },
    props: {
      arquivoEstruturado: {
        type: Array,
        default: null
      },
      tipoRegistro: {
        type: String,
        required: false,
        default: null
      }
    },
    data () {
      return {
        genitorSelecionado: null
      }
    },
    methods: {
      tratarDados (tipo, dado) {
        if (!dado) return 'Não cadastrado'
       
        switch (tipo) {
        case 'cpf':
          return this.formatarCpf(dado)

        case 'nacionalidade':
        case 'sexo':
          return this.formatarTexto(dado)

        case 'endereco':
          return this.formatarEndereco(dado)

        default:
          return dado
        }
      },
      formatarCpf (cpf) {
        cpf = cpf.toString().replace(/\D/g, '')

        if (cpf.length !== 11) return cpf

        return cpf.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          '$1.$2.$3-$4'
        )
      },
      formatarTexto (texto) {
        return texto
          .toLowerCase()
          .replace(/\b\w/g, letra => letra.toUpperCase())
      },
      formatarEndereco (endereco) {
        const cep = endereco.cep ? endereco.cep.replace(/(\d{5})(\d{3})/, '$1-$2') : null

        const enderecoFormatado = [
          `${endereco.logradouro || ''}${endereco.numero ? `, ${endereco.numero}` : ''}`,
          endereco.complemento,
          endereco.bairro,
          `${endereco.cidade || ''}${endereco.uf ? ` - ${endereco.uf}` : ''}`,
          cep
        ]

        return enderecoFormatado.filter(Boolean).join(', ')
      },
      abrirModalGenitor (genitor) {
        this.genitorSelecionado = genitor
        this.$bvModal.show('modalInformacoesGenitor')
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/scss/_utilities/_exports";

.section {
  &_header {
    @extend %titleBox;
    background-color: $color-gray-light;

    &_title {
      @extend %titleBox_title;
    }
  }
}
.boxGenitor {
  box-shadow: 0 0 pxToRem(4) 0 $color-dark;

  &_error {
    border: solid 2px #8B0000;
    border-radius: 2px;
  }

  &_header {
    background-color: #01AEC9;
    color: $color-dark;

    &_title {
      font-size: pxToRem(14);
      font-weight: 500;
    }
  }

  &_body {
    &_content {}
  }

  &_list {
    font-size: pxToRem(14);
    list-style: none;
    margin: 0;
    padding: 0;

    &_item {}

    &_title {
      margin-bottom: pxToRem(4);
      text-decoration: underline;
    }
  }
}
</style>